import React from 'react'

export default () => {
    return (
        <div>
            <i className="fa fa-spinner fa-spin" style={{ margin: 0 }} />
        </div>
    )
}
